export const PROGRAM_IMG_MAIN =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuAMCaQ2XlXeHP3y32_uBPOxzKLuN2SD-oEbzRMnJUOBtucTxRSz0dcq0_KHqQnFQZX6_S0K6HmKrjQfcNbF-SdyJ7uRXX4FSY3rzmR3h49wfF4xo25eP9P4uUKuYxPtWPcUH2bMVxw-1UewKls495NOowopub1uD7rRe6eunHCDH-jHCLf32dRnP_c5Mc4s6XH-vbeLJE_nCEu4XUZ8cR5RUr8cAZa261cc3FQyOB-b9wKPV7dCWbo_MMm-mNxVHRD_mwOdJO7UznE'

export const PROGRAM_IMG_GEN =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuAuD0nr_r7_ZH__qjFm-LyMqnaOQSZbGudS3qjdq0tixQFSjs126PdeU-xMIzFMlW15t0nCOis4BDAKlDHQBaqH70SLNmJZhMW_AvtOe04OfkwR74DbFNyFqsTCFOHBD8LSkTkCIjTSyJ64pUU4XWfMzmSYug2Lh1aykj49ztiASAKfL9BctjBd0yWEOu4muGoIJa5UIuERpQ9TkQKLjkMdnXZEe1njaWgLChiGbVMNsfZGrXhREpJDknVns4C-uecm7AHhGpaWdAQ'

export const PROGRAM_IMG_DS =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuCr15LJGqKqtE7tdbLoFCdtsS1aZSknPiBCACfw5xKMl062N1wk6TeP88P_KIIKkLKYwG7oDZYSahwDeuSPziThrLVCOQj14HEHKkt_dP5BXXAv2-zIGLg2rANW0ZBKingAF1Zt_Wv3zEjnopF06n40lgupSWS6YGfAX6TcV9ux8W49g_RwoVxWPgwbDtsvmkM-k1cz8r19tIsbvCy146NdgaCoe2gWD-z9kwkg_NT-r7hzYNLQFIthbeZTA4yxS4tu44NuPTlZAc'

export const AVATAR_1 =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuCKn_jn71RgREjb10paLlMXIpRTaf476MPTMPl8QiNbX4vdHxxQT0aNud0cKqtmzqzkL5jVgAQZU7xjfyj5LhEsZzZJpb-3zmoL_VQrkkPSIXnasoPx-H04VJZLU19fRgArBVHvQiShUDYbV5oD2qLd_CLrieR2v_I8_wRczglvppOFff4oqEjyzAJjqcsMTHjm0hjmQhFQC1EABZBVR3o3E35CcA-RRqq4-USmPHYGGZMXLoinRi6Fw0IycNUtbM-I4L-zQMf4eOU'

export const AVATAR_2 =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuAGvkF5qC1JGZtkdS69Lc_eXiPys5K67oQd5mz91aDU2JP8VFvo6HgG6u0uDs3_aIsQ2giaNUTNmswq6n7vRfi6lVWj35SaaMh84yRfJzlzaGgesZhwxGuckrO7H3UYWBxQmFzKIvwQItucCCyrCIosdvvcne-xc64hvsUobzjpyGfrDSshgXvOqaBwAqXlrKhFYKvhibAKUrYYrXT_po9R6adgM0_-dxYDUlDPRtZWXO_hdsWVSo4hB69DxN96U892XIuxBmUiwtw'

export const testimonials = [
  {
    quote:
      "The diagnostic-first approach changed everything. They didn't hand me a course — they mapped my workflow gaps and deployed an intelligence curve that integrated into my actual work.",
    name: 'Alexandre R.',
    role: 'Lead Dev',
    company: 'Mistral AI',
    avatar: AVATAR_1,
  },
  {
    quote:
      "I went from passive AI awareness to running agentic workflows in my department in under 6 months. The execution velocity is real.",
    name: 'Sarah M.',
    role: 'Data Scientist',
    company: 'DeepL',
    avatar: AVATAR_2,
  },
  {
    quote:
      'This is not a training platform — it is an Applied Intelligence Engine. The mentors operate at the frontier. Every session produces a deployment, not a note.',
    name: 'Karim B.',
    role: 'ML Engineer',
    company: 'Capgemini',
    avatar: AVATAR_1,
  },
  {
    quote:
      'Our L&D team had tried three generic AI programs. SkillsUp AI was the only one that delivered measurable productivity outcomes — not just certificates.',
    name: 'Léa T.',
    role: 'Head of L&D',
    company: 'Enterprise Group',
    avatar: AVATAR_2,
  },
] as const

export const aboutBlocks = [
  {
    icon: 'bolt' as const,
    title: 'Execution Velocity',
    text: 'Every intelligence deployment ends with a live workflow integration that week — not a quiz, not a reflection. A measurable output inside your actual operations.',
  },
  {
    icon: 'groups' as const,
    title: 'Agentic Mentorship',
    text: 'Learn from AI-native practitioners who build and deploy at enterprise scale — through live diagnostic sessions and 24/7 AI mentor agents.',
  },
  {
    icon: 'verified' as const,
    title: 'Recognized Credentials',
    text: 'Graduate with layered certifications backed by Moroccan, international, and European quality standards — credentials that travel and stand up to employer scrutiny.',
  },
] as const
